import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  getProductList (params) {
    return axios.post(global.EURLATE_MEMBER + '/product/findProduct', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/mmc/product.js